import { create } from "zustand";
import { persist } from "zustand/middleware";
import { EquipmentI, EquipmentSimpleI } from "../../../../libs/interfaces";

type State = {
  clientSelected: number | null;
  isLoading: boolean;
  equipments: EquipmentI[] | EquipmentSimpleI[];
  typeEquipment: number | null;
};

type Actions = {
  setIsLoading: (loading: boolean) => void;
  setEquipments: (equipments: EquipmentI[] | EquipmentSimpleI[]) => void;
  setClientSelected: (client: number | null) => void;
  setTypeEquipment: (typeEquipment: number | null) => void;
};

const initialState: State = {
  clientSelected: null,
  isLoading: false,
  equipments: [],
  typeEquipment: null,
};

export const useDashboardStore = create<State & Actions>()(
  persist(
    (set, get) => ({
      ...initialState,
      setIsLoading: (loading) => set({ isLoading: loading }),
      setEquipments: (equipments) => set({ equipments }),
      setClientSelected: (client) => set({ clientSelected: client }),
      setTypeEquipment: (typeEquipment) => set({ typeEquipment }),
    }),
    { name: "STORE_DASHBOARD" }
  )
);
